import { render, staticRenderFns } from "./airport-taxi-booking.vue?vue&type=template&id=6d23f603&scoped=true"
import script from "./airport-taxi-booking.vue?vue&type=script&lang=js"
export * from "./airport-taxi-booking.vue?vue&type=script&lang=js"
import style0 from "./airport-taxi-booking.vue?vue&type=style&index=0&id=6d23f603&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d23f603",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TaxiCard: require('/workspace/components/TaxiCard.vue').default,FaqCard: require('/workspace/components/FaqCard.vue').default})
